"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventStatusChangeMutationBuilder = void 0;
var graphql_tag_1 = require("graphql-tag");
var admin_events_model_1 = require("@athlinks/admin-events-model");
var eventStatusMutation = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation UpdateEventStatus($events: [EventStatusArg]) {\n      updateEventStatus(events: $events) {\n        id,\n        status,\n        success\n      }\n    }\n  "], ["\n    mutation UpdateEventStatus($events: [EventStatusArg]) {\n      updateEventStatus(events: $events) {\n        id,\n        status,\n        success\n      }\n    }\n  "])));
var eventStatusChangeMutationBuilder = function (_a) {
    var events = _a.events;
    return {
        query: eventStatusMutation,
        variables: { events: events.map(function (e) {
                return { id: e.id, status: admin_events_model_1.EventStatus[e.status] };
            }) }
    };
};
exports.eventStatusChangeMutationBuilder = eventStatusChangeMutationBuilder;
var templateObject_1;
//# sourceMappingURL=mutations.js.map